<template>
<div class="card">
    <div class="card-header">
        <p class="card-header-title">Add An Item</p>
    </div>
    <div class="card-content">
        <div class="columns">
            <div class="column is-full">
                <input class="input is-success" type="text" placeholder="Item Name" v-model="name">
            </div>
        </div>
        <div class="columns">
            <div class="column is-2" v-show="dataType != 3">
                <input class="input" type="number" placeholder="Points, e.g.: 10" v-model="points">
            </div>
            <div class="column is-2">
                <b-select id="dataType" name="dataType" v-model="dataType">
                    <option selected value="1">Normal</option>
                    <option value="2">Attendance</option>
                    <option value="4">Parents App</option>
                    <option value="5">Subject Attendance</option>
                </b-select>
            </div>
            <div class="column is-3" v-show="dataType != 4">
                <b-select id="restrictAwardBy" name="restrictAwardBy" v-model="restrictAwardBy">
                    <option selected value="1">Used by everyone</option>
                    <option value="2">Used only by class/department teachers/supervisors</option>
                    <option value="3">Used only by selected teachers/supervisors</option>
                </b-select>
            </div>
        </div>

        <div class="columns">
            <div class="column is-3" v-show="(dataType == 1 || dataType == 4 || dataType == 5)">
                <input class="input" type="number" placeholder="Scale Limit, eg.: 5" v-model="scaleLimit">
            </div>

            <div class="column is-3">                
                <b-select id="submissionLimitType" name="submissionLimitType" v-model="submissionLimitType">
                    <option value="1">Limit daily submission</option>
                    <option value="2">Limit yearly submission</option>
                    <option value="-1">DON'T Limit Submission Count</option>
                </b-select>
            </div>

            <div class="column is-1" v-show="(dataType == 1 || dataType == 4 || dataType == 5) && (submissionLimitType > 0)">                
                <input class="input" type="number" placeholder="E.g.: 5" v-model="submissionLimit">
            </div>
        </div>

        <div class="columns">
            <div class="column is-3">
                <slider-picker v-model="colour" />
            </div>
        </div>
        <div class="columns">
            <div class="column is-6">
                <input class="input is-success" type="text" placeholder="Optional details about the item" v-model="info">
            </div>
        </div>

        <div class="columns" v-show="(dataType == 1 && restrictAwardBy == 1)">
            <div class="column is-full">
                <div class="field">
                    <label class="label">Is this item mandatory for each submission?</label>
                    <div class="control">
                        <label class="radio">
                            <input type="radio" v-model="isMandatory" value="0">
                            No
                        </label>
                        <label class="radio">
                            <input type="radio" v-model="isMandatory" value="1">
                            Yes
                        </label>
                        <div v-show="isMandatory == 1" style="color: red;">
                            Take note that by selecting this item as mandatory, you will NOT BE ABLE TO do any submission unless you selected this item too.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column is-full">
                <div class="field">
                    <label class="label">Is remarks mandatory for this item?</label>
                    <div class="control">
                        <label class="radio">
                            <input type="radio" v-model="isRemarksMandatory" value="0">
                            No
                        </label>
                        <label class="radio">
                            <input type="radio" v-model="isRemarksMandatory" value="1">
                            Yes
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column is-full"><button class='button is-primary  is-fullwidth' v-on:click="sendForm()" >Create</button></div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Slider } from 'vue-color'

export default {
    name: "SuperItemAdd",
    components:{
        Multiselect,
        Loading,
        'slider-picker': Slider,
    },
    data() {
        return {
            isLoading: false,
            isLoading1: false,
            name: '',
            points: "",
            dataType: 1,
            restrictAwardBy: 1,
            scaleLimit: 5,
            submissionLimitType: 1,
            submissionLimit: 5,
            colour: '#0C4BF7',
            info: "",
            isMandatory: 0,
            isRemarksMandatory: 0
        };
    },
    created() {
    },
    methods: {
        sendForm() {
            let self = this;

            var name = self.name;
            var points = self.points;
            var dataType = self.dataType;
            var restrictAwardBy = self.restrictAwardBy;
            var scaleLimit = self.scaleLimit;
            var submissionLimitType = self.submissionLimitType;
            var submissionLimit = self.submissionLimit;
            var colour = self.colour;
            var info = self.info;
            var isMandatory = self.isMandatory;
            var isRemarksMandatory = self.isRemarksMandatory;
            var selectedColour = "#0C4BF7";

            if ((!name) || (name.length < 1)){
                Toast.open({
                    message: "Please enter the item name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                name = name.trim()
            }
            if (!points){
                points = 0
            }
            if (dataType != 3){
                if (points == 0){
                    Toast.open({
                        message: "Please enter the points for this item",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }
            if (dataType != 1){
                isMandatory = 0;    //isMandatory is only available for normal item
            }
            if (restrictAwardBy != 1){
                isMandatory = 0;    //isMandatory is only available for items that can be submitted by all
            }
            if (!colour.hex){
                selectedColour = "#0C4BF7"
            }else{
                selectedColour = colour.hex
            }
            if (dataType != 1){
                isMandatory = 0;    //isMandatory is only available for normal item
            }

            if (scaleLimit > 50){
                this.$swal('Sorry, scale limit can not be more than 50!');
                return false;
            }else{
                scaleLimit = parseInt(scaleLimit)
                if (scaleLimit === parseInt(scaleLimit, 10)){
                    console.log("masuk 226")
                    if (scaleLimit < 1){
                        Toast.open({
                            message: "Please enter the daily or yearly scale for the item " + name,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                        return false;
                    }
                }else{
                    Toast.open({
                        message: "Please enter the daily or yearly scale for the item " + name,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
                console.log("243")
            }

            if (submissionLimitType < 1){
                this.$swal({
                    title: "Are you sure? ",
                    text: "Are you really sure you want to set this item " + name + "'s submission count to UNLIMITED?",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: `Yes, make this item submission UNLIMITED`,
                    denyButtonText: `No, let me fix this`,
                }).then((result) => {
                    if (result.isConfirmed) {
                        console.log("232 ok continue")
                        this.continueAdd(self,name,points,dataType,restrictAwardBy,scaleLimit,submissionLimitType,submissionLimit,selectedColour,info,isMandatory,isRemarksMandatory)
                    } else if (result.isDenied) {           
                        console.log("235 return false")          
                        return false;
                    }
                })
            }else{
                submissionLimit = parseInt(submissionLimit)
                if (submissionLimit === parseInt(submissionLimit, 10)){
                    console.log("masuk 242")
                    if (submissionLimit < 1){
                        Toast.open({
                            message: "Please enter the daily or yearly submission limit for the item " + name,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                        return false;
                    }else{
                        this.continueAdd(self,name,points,dataType,restrictAwardBy,scaleLimit,submissionLimitType,submissionLimit,selectedColour,info,isMandatory,isRemarksMandatory)
                    }
                }else{
                    Toast.open({
                        message: "Please enter the daily or yearly submission limit for the item " + name,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
                console.log("261")
            }
        },
        continueAdd(self,name,points,dataType,restrictAwardBy,scaleLimit,submissionLimitType,submissionLimit,selectedColour,info,isMandatory,isRemarksMandatory){
            console.log("masuk 219 with name: " + name + ", points: " + points + ", dataType: " + dataType)

            self.isLoading1 = true;
            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/item/add", {
                    superEmail: localStorage.getItem("superEmail"),
                    name: name,
                    points: points,
                    dataType: dataType,
                    restrictAwardBy: restrictAwardBy,
                    scaleLimit: scaleLimit,
                    submissionLimitType: submissionLimitType,
                    submissionLimit: submissionLimit,
                    colour: selectedColour,
                    info: info,
                    isMandatory: isMandatory,
                    isRemarksMandatory: isRemarksMandatory
            })
            .then(response => {
                if (response.data.success == true) {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-success', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                } else {
                    Toast.open({
                        message: e.response.data.msg,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                }
                self.isLoading1 = false;
                self.name = ""
                self.points = ""
                self.dataType = 1
                self.restrictAwardBy = 1
                self.scaleLimit = 5
                self.submissionLimitType = 1
                self.submissionLimit = 5
                self.info = ""
                self.isMandatory = 0
                self.isRemarksMandatory = 0
                self.$parent.getItems()
            })
            .catch(e => {
                console.log(e.response);
                if (e.response.status == 400) {
                    Toast.open({
                        message: e.response.data.msg,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                } else {
                    Toast.open({
                        message:
                            "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                }
                self.isLoading1 = false;
            });
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.vertical-center{
    display: flex;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Super/ItemAdd.vue